module.exports = __webpack_public_path__ + "img/image-logo-03.bb669ce1.png";